import React, { useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaStar, FaUsers, FaQuoteLeft } from 'react-icons/fa';
import './ClientsPreview.css';

const SURPRISE_QUOTES = [
  '3000 clients. 20 years. One team.',
  'From SMEs to enterprise — we power them all.',
  'Every number behind our stats is a real business we helped grow.',
  'Technology is only as good as the people who back it.',
  '5★ rating from Tally. Priceless rating from our clients.',
];


/* First 16 logos for preview — actual Client page has all 50+ */
const LOGO_PREVIEW = [
  '/images/Customer_logo/ampa-skyone.png',
  '/images/Customer_logo/2.jpg',
  '/images/Customer_logo/3.png',
  '/images/Customer_logo/4.jpg',
  '/images/Customer_logo/5.jpg',
  '/images/Customer_logo/7.png',
  '/images/Customer_logo/8.jpg',
  '/images/Customer_logo/9.gif',
  '/images/Customer_logo/jupiter_logo.png',
  '/images/Customer_logo/10.jpg',
  '/images/Customer_logo/11.JPG',
  '/images/Customer_logo/12.JPG',
  '/images/Customer_logo/ttdc-logo.png',
  '/images/Customer_logo/melss-logo.png',
  '/images/Customer_logo/rccl-logo.png',
  '/images/Customer_logo/indus.png',
];

const STATS = [
  { icon: <FaUsers />, value: '3000+', label: 'Enterprise Clients' },
  { icon: <FaStar />,  value: '20+',  label: 'Years of Excellence' },
  { icon: <FaStar />,  value: '5★',   label: 'Tally Partner Rating' },
];

const ClientsPreview = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  const navigate = useNavigate();

  // Easter Egg: 3-second hover on the View All tile
  const [surpriseVisible, setSurpriseVisible] = useState(false);
  const [surpriseQuote] = useState(() => SURPRISE_QUOTES[Math.floor(Math.random() * SURPRISE_QUOTES.length)]);
  const hoverTimerRef = useRef(null);

  const handleMoreMouseEnter = () => {
    hoverTimerRef.current = setTimeout(() => setSurpriseVisible(true), 3000);
  };
  const handleMoreMouseLeave = () => {
    clearTimeout(hoverTimerRef.current);
    setSurpriseVisible(false);
  };


  return (
    <section className="clients-preview" id="clients" ref={ref}>
      <div className="clients-preview__inner">
        {/* Left: stats + CTA */}
        <motion.div
          className="clients-preview__left"
          initial={{ opacity: 0, x: -30 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className="section-eyebrow">Our Clients</span>
          <h2 className="section-title">
            Trusted by <span className="highlight-text">3000+ Businesses</span> Across India
          </h2>
          <p className="section-subtitle" style={{ textAlign: 'left', maxWidth: '440px' }}>
            From SMEs to enterprise conglomerates, our technology solutions power growth for businesses across Tamil Nadu and beyond.
          </p>

          <div className="clients-stats-row">
            {STATS.map(s => (
              <div key={s.label} className="clients-stat">
                <span className="clients-stat__value">{s.value}</span>
                <span className="clients-stat__label">{s.label}</span>
              </div>
            ))}
          </div>

          <button className="btn-primary" onClick={() => navigate('/Client')}>
            Meet Our Clients <FaArrowRight />
          </button>
        </motion.div>

        {/* Right: logo grid */}
        <motion.div
          className="clients-preview__right"
          initial={{ opacity: 0, x: 30 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          <div className="clients-logo-grid">
            {LOGO_PREVIEW.map((src, i) => (
              <motion.div
                key={i}
                className="clients-logo-item"
                initial={{ opacity: 0, scale: 0.85 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.4, delay: 0.1 + i * 0.04 }}
              >
                <img src={src} alt={`Client logo ${i + 1}`} loading="lazy" />
              </motion.div>
            ))}
            {/* Overflow indicator */}
              <div
                className="clients-logo-more"
                onClick={() => navigate('/Client')}
                onMouseEnter={handleMoreMouseEnter}
                onMouseLeave={handleMoreMouseLeave}
                style={{ position: 'relative' }}
              >
                {surpriseVisible ? (
                  <div style={{
                    position: 'absolute', inset: 0, borderRadius: 'inherit',
                    background: 'linear-gradient(135deg, #6b7a52, #4a5c35)',
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    padding: '10px', gap: 6,
                    animation: 'ctx-menu-in 0.3s ease forwards'
                  }}>
                    <FaQuoteLeft style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem' }} />
                    <p style={{ fontSize: '0.7rem', color: '#fff', textAlign: 'center', margin: 0, lineHeight: 1.4, fontStyle: 'italic' }}>
                      {surpriseQuote}
                    </p>
                    <p style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.6)', margin: 0 }}>— iMatrix Technologies</p>
                  </div>
                ) : (
                  <>
                    <FaArrowRight className="clients-logo-more__icon" />
                    <span className="clients-logo-more__label">View All</span>
                  </>
                )}
              </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsPreview;
